import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Container from '../../components/shared/Container';
import { testSanityConnection } from '../../lib/sanity';

export default function MenuTestPage() {
  const [testResult, setTestResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function runTest() {
      try {
        console.log('MenuTestPage: Starting Sanity connection test...');
        setLoading(true);
        
        const result = await testSanityConnection();
        console.log('MenuTestPage: Test result:', result);
        setTestResult(result);
        
        if (!result.success) {
          setError(`Connection test failed: ${result.error}`);
        }
      } catch (err) {
        console.error('MenuTestPage: Error running test:', err);
        setError(`Test error: ${err.message}`);
      } finally {
        setLoading(false);
      }
    }

    runTest();
  }, []);

  return (
    <div className="bg-brand-cream min-h-screen py-32">
      <Container>
        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-heading text-brand-navy mb-6">Sanity Connection Test</h1>
          
          {loading ? (
            <div className="flex items-center space-x-4">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-brand-navy"></div>
              <p>Testing connection to Sanity...</p>
            </div>
          ) : error ? (
            <div className="bg-red-50 border border-red-200 rounded p-4 mb-6">
              <h2 className="text-red-700 font-bold mb-2">Error</h2>
              <p className="text-red-600">{error}</p>
            </div>
          ) : (
            <div className="space-y-6">
              <div className="bg-green-50 border border-green-200 rounded p-4 mb-6">
                <h2 className="text-green-700 font-bold mb-2">Connection Successful</h2>
                <p className="text-green-600">Successfully connected to Sanity API</p>
              </div>
              
              <div>
                <h2 className="text-xl font-bold text-brand-navy mb-2">Test Response Data:</h2>
                <pre className="bg-gray-100 p-4 rounded overflow-auto max-h-96">
                  {JSON.stringify(testResult, null, 2)}
                </pre>
              </div>
            </div>
          )}
          
          <div className="mt-8">
            <Link 
              to="/menu" 
              className="text-brand-navy hover:text-brand-orange underline"
            >
              Return to Menu Page
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
}
